import { Box, ThemeProvider } from "@mui/material";
import { RPMText } from "./subComponents/RPMText";
import { generateTheme } from "../themes";
import { RPMButton } from "./subComponents/RPMButton";


const TopSubpageSlice = ({ sliceData, color = "text.primary", direction = "row" }) => {

    const themeName = sliceData.color_theme ?? "monotheme";

    const theme = generateTheme(themeName);

    const getButtonLink = (linkData) => {
        if (!linkData) return null;
        if (typeof linkData === 'string') {
            if (linkData.includes('#')) {
                return { url: "#" + linkData.split("#")[1], type: "internal" };
            }
            return { url: linkData };
        }
        if (typeof linkData === 'object' && linkData.url) {
            return linkData;
        }
        return null;
    }

    // Support both Prismic (sliceData.link.url) and WordPress (sliceData.link as string/object) formats
    const linkUrl = sliceData.link?.url || (typeof sliceData.link === 'string' ? sliceData.link : null);
    const buttonLink = getButtonLink(linkUrl);

    // Support both Prismic (sliceData.linktext[0].text) and WordPress (sliceData.linktext as string) formats
    const linkText = Array.isArray(sliceData.linktext) ? sliceData.linktext[0]?.text : sliceData.linktext;

    // Support both Prismic (array) and WordPress (string) for title and subtitle
    const titleContent = sliceData.title1 || sliceData.title;
    const subtitleContent = sliceData.subtitle;

    return (
        <ThemeProvider theme={theme}>

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", pt: "6rem", pb: "2rem", background: (theme) => theme.palette.background.default }}>
                <RPMText content={titleContent} priscmicField={titleContent} variant="h2" sx={{ textAlign: "center" }} elementRenderType="h1" />
                <RPMText content={subtitleContent} priscmicField={subtitleContent} variant="h2" elementRenderType={"h2"}
                    sx={{
                        pl: "1rem",
                        color: color,
                        letterSpacing: "0.00938em",
                        lineHeight: "1.167",
                        fontFamily: "Kanit, Roboto, Helvetica, Arial, sans-serif",
                        textTransform: "inherit",
                        fontWeight: 400,
                        marginTop: "0rem",
                        fontSize:
                        {
                            xs: "1.21rem",
                            sm: "1.9rem",
                            md: "1.94rem",
                        },
                        textAlign: "left",
                        alignContent: "flex-start",
                    }} />

                {buttonLink && linkText && (
                    <Box sx={{ px: { xs: "0", sm: "1rem" }, pt: "0", color: "color" }}>
                        <RPMButton link={buttonLink} linktext={linkText} size="large" type="text" />
                    </Box>
                )}
            </Box>
        </ThemeProvider >
    );
}

export default TopSubpageSlice;